import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--admins-form"
export default class extends Controller {
  static targets = ["form", "username", "email", "submit"]

  edit(event) {
    const row = event.currentTarget
    const url = row.dataset.url
    Turbo.visit(url, { frame: "admin-admin-form" })
  }
}
